module.exports = __webpack_public_path__ + "static/media/close.b6586390.svg";